import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CustomizedHttpService } from "../base/customized-http.service";
import { IPTrackerSettingsConfigModel, IPTrackerSettingsModel } from "../../models/start-up-config/ip-tracker-settings-config.model";
import { TrackUserIpRequestModel } from "../../models";
import { CookieService } from "../util/cookie.service";
import { take } from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class IPTrackerService {

  //TODO : Move api calls thru CustomizedHttpService and other pending work of tracker

  constructor(
    private httpService: CustomizedHttpService,
    private cookieService: CookieService,
    private _httpClient: HttpClient, @Inject('BASE_URL') private originUrl: string) { }

  initIPTracker(ipTrackerSettings: IPTrackerSettingsConfigModel, sessionTrackingId) {
    if (!ipTrackerSettings.isEnabled)
      return;

    //Get value from cookie to check if already stored for the same session
    var IsNewSession = this.CheckIfNewSession(ipTrackerSettings.settings.cookieKey);
    if (IsNewSession) {
      this.getIPDetails(ipTrackerSettings.settings, sessionTrackingId);
    }

    //return this.httpService.post<any, null>("ipTracker/initIPTracker", request);
  }

  getIPDetails(trackerSettings: IPTrackerSettingsModel, sessionTrackingId: string) {
    this._httpClient.get(trackerSettings.getIPDetailsApiEndPoint).pipe(take(1)).subscribe(response => {
      if (response != null) {

        var details = new TrackUserIpRequestModel();
        details.ipAddress = response["query"];
        details.latitude = response["lat"];
        details.longitude = response["lon"];
        details.zipCode = response["zip"];
        details.autonomousSystemNumber = response["as"];
        details.city = response["city"];

        this.saveIPDetails(details);

        //Set value to cookie to prevent the same session entry
        this.cookieService.set(trackerSettings.cookieKey, 'true', 1);
      }
    }, err => console.log('HTTP Error (getIPDetails): ', err));
  }

  saveIPDetails(request: TrackUserIpRequestModel) {
    this.httpService.post<any, any>(`${this.originUrl}tracker/TrackUserIp`, request)
      .pipe(take(1)).subscribe(res => {
        console.log(res);
      }, err => console.log('HTTP Error (saveIPDetails): ', err));
  }

  CheckIfNewSession(key): boolean {
    return this.cookieService.get(key) === "false" || this.cookieService.get(key) === "" ? true : false;
  }
}
